export type FeatureKey = "meetings" | "client" | "documents" | "tasks" | "forms";

export const FEATURE_ORDER: FeatureKey[] = ["meetings", "client", "documents", "tasks", "forms"];

export const FEATURE_LABEL: Record<FeatureKey, string> = {
  meetings: "Meetings",
  client: "Client View",
  documents: "Documents",
  tasks: "Tasks",
  forms: "Forms",
};

export const FEATURE_OUTCOME: Record<FeatureKey, string> = {
  meetings: "User had at least one meeting that week.",
  client: "User sent at least one Ask Marloo chat inside a Client View that week.",
  documents: "User created at least one document that week.",
  tasks: "User updated at least one task that week.",
  forms: "User filled at least one form that week.",
};

export const OVERALL_OUTCOME =
  "User took at least one action in the product in a given week.";

export const FEATURE_DEFINITION: Record<FeatureKey, string> = {
  meetings:
    "User has at least one row in public.meeting_synopsis that week (keyed on user_external_id and created_date_utc).",
  client:
    "User sent a chat_message (role = user) inside a chat where chat.type = 'client' that week. For chats created before chat.type was populated (~2026-04-20), a chat with a non-null client_external_id is treated as a Client View chat.",
  documents:
    "User has at least one row in public.document that week (keyed on user_external_id and created_date_utc).",
  tasks:
    "User updated a task (task_activity.activity_type = 'task-updated', created_by_user_external_id) OR sent a chat_message (role = user) in a chat where chat.type = 'task' OR sent a chat_message that has a row in chat_message_task_part.",
  forms:
    "User has at least one row in public.filled_form that week (keyed on created_by_user_external_id and created_date_utc).",
};

export const OVERALL_DEFINITION =
  "User is active in any of the five features (meetings, Client View, documents, tasks, forms) within the week. WAU = distinct active users in that week.";
